import Notices from './Index.vue'

Notices.install = function (Vue) {
  Vue.component(Notices.name, Notices)
}

export default Notices
